import { IConfig } from '@cian/config/shared';
import { PRIVACY_POLICY_LINK } from '../../../../constants/links';

const PRIVACY_POLICY_CONFIG_KEY = 'newbuilding-consultants-frontend.privacyPolicyUrl';

export const getPrivacyPolicyUrl = (config: IConfig): string => {
  return config.get<string>(PRIVACY_POLICY_CONFIG_KEY) || PRIVACY_POLICY_LINK;
};
